import request from "@/utils/request";
import {IAddShippingModel} from "./types";

export const defaultShippingData: IAddShippingModel = {
    id: null,
    shippingCode: null,
    sellerId: null,
    customerId: null,
    code: null,
    name: null,
    abbreviation: null,
    customerAddress: null,
    tel: null,
    country: null,
    departures: null,
    tradeCountry: null,
    departure: null,
    transportation: null,
    destinationCountry: null,
    deliveryCountry: null,
    portDischarge: null,
    internationalTradeTerms: null,
    payment: null,
    paymentDetails: null,
    ladingType: null,
    notifier: null,
    notifierAddress: null,
    startDate: null,
    combinedContainer: null
};

export const creatShipping = (data: any) =>
    request({
        url: "/shipping-orders",
        method: "post",
        data
    });

export const getShipping = (params: any) =>
    request({
        url: "/shipping-orders/options",
        method: "get",
        params
    })


